import React from 'react';
/**
 * Renders a two-row layout component where one row can take full height (1fr) and the other auto height.
 * Each row can optionally be scrollable.
 *
 * @param {LayoutRows2Props} props - Props for configuring the two-row layout.
 * @param {React.ReactNode} [props.row1] - Optional content to render in the first row.
 * @param {React.ReactNode} [props.row2] - Optional content to render in the second row.
 * @param {'row1' | 'row2'} props.fullHeightRow - Specifies which row should take full remaining height.
 * @param {boolean} [props.row1Scrollable] - Whether the first row should be scrollable.
 * @param {boolean} [props.row2Scrollable] - Whether the second row should be scrollable.
 * @param {string} [props.data-test] - Optional data-test attribute for testing.
 * @returns {JSX.Element} A layout with two rows.
 */
export const LayoutRows2 = (props) => {
    const fhr = props.fullHeightRow;
    return (React.createElement("div", { style: {
            display: 'grid',
            width: '100%',
            height: '100%',
            gridTemplateRows: size(fhr === 'row1') + ' ' + size(fhr === 'row2'),
            gridTemplateColumns: '100%',
        }, "data-test": props['data-test'] },
        React.createElement("div", { style: { overflow: props.row1Scrollable ? 'auto' : fhr === 'row1' ? 'hidden' : undefined, gridRow: '1/2' }, "data-test": 'row1' }, props.row1 && props.row1),
        React.createElement("div", { style: { overflow: props.row2Scrollable ? 'auto' : fhr === 'row2' ? 'hidden' : undefined, gridRow: '2/3' }, "data-test": 'row2' }, props.row2 && props.row2)));
};
function size(full) {
    return full ? '1fr' : 'auto';
}
